import { Route, Routes } from 'react-router-dom';
import { RouteMeta } from './components/RouteMeta';
import { CheckoutPage } from './pages/CheckoutPage';
import { CheckoutCompletePage } from './pages/CheckoutCompletePage';
import { HomePage } from './pages/HomePage';
import { LegalPage } from './pages/LegalPage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PricingPage } from './pages/PricingPage';
import { SupportPage } from './pages/SupportPage';
import { WorkspacePage } from './pages/WorkspacePage';

export function App() {
  return (
    <>
      <RouteMeta />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/workspace" element={<WorkspacePage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/complete" element={<CheckoutCompletePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/terms" element={<LegalPage />} />
        <Route path="/privacy" element={<LegalPage />} />
        <Route path="/refund-policy" element={<LegalPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
